export default __webpack_public_path__ + "static/media/beeple.fa7df6d7.png";